import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {LoadingSpinner} from '../loadingSpinner/LoadingSpinner'
import "./ChildForgotPassword.css";
import { callApi } from "../auth/ApiService";
import common from "../config/common.json";
import { useIntl } from 'react-intl';
import icon from "../config/icon.json"


function ChildForgotPassword() {
  const [isLoading, setIsLoading] =useState(false);
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const intl = useIntl();

  const signIn = () => {
    navigate("/");
  };

  const isEmailValid = (email) => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return regex.test(email);
  }

  const otpSend=()=>{
    if(isEmailValid(email)){
      confirmCodeSend();
    }else{
      setError("Please enter valid email")
    }
  }

  const confirmCodeSend = async () => {
    console.log("this is calling all data ")
    setIsLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var raw = JSON.stringify({
      username: email,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const result = await callApi(`${common.BASEURL}/forgotPassword`,requestOptions);
      var data = JSON.parse(result.body);
      if(data.success){

        localStorage.setItem("ForgetUser",email)
        setIsLoading(false);
        navigate("/resetpassword");
      }else{
        setIsLoading(false);
        setError(data.msg)
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  return (
    <div>

    <div className={("Forget_wrapper responsive_wrapper")}>
        <div className="main_logo_forget_password">
          <img src={`/assets/image/${common.ClientId}_logo.png`} className={("logo")} />
        </div>
      <div className={("hero_title")}>
        <h3 className={("font_main_color light forget_password_title")}>Forgot Password</h3>
      </div>      
    <div>
      <div className="error">{error}</div>
      <form onSubmit={(e) => {
        e.preventDefault();
              if(isLoading){
                return 0;
              }
        otpSend();
      }}>
        <label>
          <input className={("input_edit")}  placeholder="Enter E-mail"
          type="email"
          autoFocus
          id="email"
          onChange={(e) => {
            setError("")
            setEmail(e.target.value);
          }}
          required
          />
        </label>
        <div className="button_main_forget_password">
          <button className={("btn_main_forgot_password btn_sign_in_forgot_password send_button_forget_password")} type="submit">
          {isLoading ?"Sending..." : "Send" }
          </button>
          <div>
          <a className={("font_main_color sign_in_forget_password")} onClick={signIn}>
      Sign in
      </a>
          </div>
        </div>
        
      </form>
      
    </div>
    </div>
  
    </div>
  );
}

export default ChildForgotPassword;
